import "./Menu.module.css";
import Header from "@/reusable_sections/Header";
import MenuHero from "./sections/MenuHero";
import MenuCategories from "./sections/MenuCategories";
import ALaCarteAndSides from "./sections/ALaCarteAndSides";
import SpecialsAndDrinksCta from "./sections/SpecialsAndDrinksCta";
import Footer from "@/reusable_sections/Footer";
export default function MenuPage() {
  return <div>
      <Header />
      <MenuHero />
      <MenuCategories />
      <ALaCarteAndSides />
      <SpecialsAndDrinksCta />
      <Footer />
    </div>;
}